import AlignmentEditor from './AlignmentEditor';

export default AlignmentEditor;
